export const cleanSchema = (obj) => {
  if (Array.isArray(obj)) {
    return obj
      .map((item) => cleanSchema(item))
      .filter(
        (item) =>
          !(
            typeof item === "object" &&
            item !== null &&
            Object.keys(item).length === 0
          )
      );
  } else if (obj && typeof obj === "object") {
    let cleaned = Object.fromEntries(
      Object.entries(obj)
        .filter(([key, value]) => {
          if (["fieldKey", "itemIndex", "sectionKey"].includes(key))
            return false;
          if (key === "TOOLTIP" && (value === "" || value == null))
            return false;
          return true;
        })
        .map(([key, value]) => [key, cleanSchema(value)])
    );

    if ("CONDITION" in cleaned) {
      const cond = cleaned.CONDITION;

      if (Array.isArray(cond.Value)) {
        cond.Value = cond.Value.filter(
          (v) => v && typeof v === "object" && v.Value !== "" && v.Value != null
        );
      }

      if (!Array.isArray(cond.Value) || cond.Value.length === 0) {
        delete cleaned.CONDITION;
      }
    }

    return cleaned;
  }
  return obj;
};

export const reorderAttachmentsAndCaseNotesLast = (configObj) => {
  if (!configObj || typeof configObj !== "object") return configObj;

  const entries = Object.entries(configObj);
  const attachmentEntries = entries.filter(([k]) => k === "ATTACHMENTS");
  const caseNoteEntries = entries.filter(([k]) => k === "CASE_NOTES");
  const otherEntries = entries.filter(
    ([k]) => k !== "ATTACHMENTS" && k !== "CASE_NOTES"
  );

  const reordered = [...otherEntries, ...attachmentEntries, ...caseNoteEntries];

  return Object.fromEntries(reordered);
};
